// extracted by mini-css-extract-plugin
module.exports = {"TitleandImagewrapper":"TitleAndImages_TitleandImagewrapper__qWZEx"};